// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle[data-v-06f38c18],.v-card>h2[data-v-06f38c18]{color:#1e88e5;font-weight:700}a[data-v-06f38c18]{text-decoration:none}.right[data-v-06f38c18]{float:right}.carlist[data-v-06f38c18],.scrolling .v-tabs-items.full-height-tab .v-window-item[data-v-06f38c18]{height:calc(100vh - 65px);width:100%;overflow-y:auto;overflow-x:hidden}.carlist[data-v-06f38c18]{height:100vh}", ""]);
// Exports
module.exports = exports;
